export default function buildManifestacaoFormData(
  dados,
  arquivos = [],
  { removerAnexosIds = [] } = {},
) {
  const form = new FormData();

  Object.entries(dados).forEach(([key, value]) => {
    if (value != null && value !== '') {
      form.append(key, value);
    }
  });

  if (removerAnexosIds.length) {
    form.append('removerAnexosIds', JSON.stringify(removerAnexosIds));
  }

  arquivos.forEach(arquivo => {
    form.append('files', arquivo);
  });

  return form;
}
